import {
    AfterContentChecked,
    Component, DestroyRef,
    ElementRef,
    HostListener, inject,
    Input, OnInit,
    ViewEncapsulation
} from '@angular/core';
import { Locale, LocaleMappings } from '@emm/core/models/locale.model';
import { SharedFacadeService } from '../../services/shared-facade.service';
import { take, withLatestFrom } from 'rxjs/operators';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

const PLACEHOLDER = 'Locale...';

@Component({
    encapsulation: ViewEncapsulation.None,
       host: { '(document:click)': 'onOutsideClick($event)' },
    selector: 'emm-locales-select',
    styleUrls: ['./locales-select.component.scss'],
    templateUrl: './locales-select.component.html',
    standalone: false
})
export class LocalesSelectComponent implements OnInit, AfterContentChecked {

    private readonly destroyRef: DestroyRef = inject(DestroyRef);

    @Input() languagesOnlyOfCountry: string;

    active = false;
    $event: Event;
    localeOptions: Locale[];
    localeMappings: LocaleMappings;

    localeSelected: Locale;

    placeholder = PLACEHOLDER;
    width = 0;

    @HostListener('click')
    handleClick(): void {
        this.active = !this.active;
    }

    constructor(
        private element: ElementRef,
        private sharedFacade: SharedFacadeService) {}

    ngOnInit(): void {
        this.sharedFacade.localeMappings$
            .pipe(
                takeUntilDestroyed(this.destroyRef)
            )
            .subscribe(mappings => this.localeMappings = mappings);

        this.sharedFacade.localeSelected$
            .pipe(
                takeUntilDestroyed(this.destroyRef)
            )
            .subscribe(locale => this.localeSelected = locale);

        this.sharedFacade.localeOptions$
            .pipe(withLatestFrom(this.sharedFacade.localeSelected$), take(1), takeUntilDestroyed(this.destroyRef))
            .subscribe(([options, localeSelected]) => {
                if (options && options.length && this.languagesOnlyOfCountry) {

                    this.localeOptions = options
                        .filter(option => option.country === this.languagesOnlyOfCountry && option.language);

                    let currentLocale = this.localeOptions[0];

                    if (localeSelected
                        && localeSelected.country !== 'US'
                        && localeSelected.language !== ''
                        && this.localeOptions.length) {

                        const selectedOption = this.localeOptions
                            .filter(option => option.country === localeSelected.country
                                && option.language === localeSelected.language);

                        if (selectedOption && selectedOption.length) {
                            currentLocale = selectedOption[0];
                        }
                    }

                    this.sharedFacade.selectedLocale(currentLocale);
                    return;
                }
                this.localeOptions = options;
            });
    }

    ngAfterContentChecked(): void {
        this.width = this.element.nativeElement.children[0].offsetWidth || 0;
    }

    handleSelected(locale): void {
        // todo: how can we influence the dynamic form fields from here or each time the user selects a new locale?
        this.sharedFacade.selectedLocale(locale);
    }

    onOutsideClick(event: Event): void {
        if (!this.element.nativeElement.contains(event.target)) {
            this.active = false;
        }
    }

}
